<script>
  import { tilesInfo } from 'stores/navigation'
  import { createQuery } from '@tanstack/svelte-query'
  import { getTiles } from 'services/api/apiCalls'

  const queryGetTileList = createQuery({
    queryKey: ['tiles'],
    queryFn: () => getTiles(),
  })

  // Svelte 5: Replace .subscribe() with $effect
  $effect(() => {
    const queryState = $queryGetTileList
    if (queryState.data && !queryState.isLoading) {
      tilesInfo.set(queryState.data)
    }
  })
</script>
